import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Chip,
  Divider,
  IconButton,
  useTheme,
  useMediaQuery,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import {
  Close as CloseIcon,
  School as SchoolIcon,
  Book as BookIcon,
  Info as InfoIcon
} from '@mui/icons-material';
import { PLATFORM_DETAILS } from '../../config/PlatformDetails';

const PlatformDetailsDialog = ({ open, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));



  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : 2,
          maxHeight: isMobile ? '100vh' : '90vh'
        }
      }}
    >
             <DialogTitle
         sx={{
           display: 'flex',
           justifyContent: 'space-between',
           alignItems: 'center',
           pb: 1,
           background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
           color: 'white'
         }}
       >
         <Box display="flex" alignItems="center" gap={1}>
           <SchoolIcon />
           <Typography variant="h5" fontWeight="bold">
             {PLATFORM_DETAILS.title}
           </Typography>
         </Box>
         <IconButton
           onClick={onClose}
           sx={{ color: 'white' }}
           size="large"
         >
           <CloseIcon />
         </IconButton>
       </DialogTitle>

               <DialogContent sx={{ pt: 9, px: 3, pb: 3 }}>

                 <TableContainer component={Paper} elevation={2} sx={{ maxHeight: 500, overflowY: 'auto', mt: 2 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                                 <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'grey.700', color: 'white' }}>
                   Board
                 </TableCell>
                 <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'grey.700', color: 'white' }}>
                   Subject
                 </TableCell>
                 <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'grey.700', color: 'white' }}>
                   Academic Years
                 </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {PLATFORM_DETAILS.coverage.map((item, index) => (
                <TableRow key={index} hover>
                  <TableCell sx={{ fontWeight: 600, color: 'primary.main' }}>
                    {item.board}
                  </TableCell>
                  <TableCell sx={{ fontWeight: 600, color: 'secondary.main' }}>
                    {item.subject}
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {item.years.map((year, yearIndex) => (
                        <Chip
                          key={yearIndex}
                          label={year}
                          size="small"
                          variant="outlined"
                          sx={{ fontSize: '0.7rem' }}
                        />
                      ))}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Additional Information */}
        <Box sx={{ mt: 3, p: 2, bgcolor: 'grey.50', borderRadius: 2 }}>
          <Box display="flex" alignItems="center" gap={1} mb={1}>
            <InfoIcon color="info" />
            <Typography variant="subtitle2" fontWeight="600" color="info.main">
              Platform Information
            </Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
            {PLATFORM_DETAILS.note}
          </Typography>
                     <Typography variant="caption" color="text.secondary">
             Last updated: {typeof PLATFORM_DETAILS.last_updated === 'function' ? PLATFORM_DETAILS.last_updated() : PLATFORM_DETAILS.last_updated}
           </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Button
          onClick={onClose}
          variant="contained"
          size="large"
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            px: 4,
            py: 1.5,
            fontWeight: 600
          }}
        >
          Got it!
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PlatformDetailsDialog;
